import birthday1 from './/birthday1.jpg';
import birthday2 from './/birthday2.jpg';
import birthday3 from './/birthday3.jpg';
import birthday4 from './/birthday4.jpg';
import birthday5 from './/birthday5.jpg';
import birthday6 from './/birthday6.jpg';
import birthday7 from './/birthday7.jpg';
import birthday8 from './/birthday8.jpg';
import birthday9 from './/birthday9.jpg';
import birthday10 from './/birthday10.jpg';
import birthday11 from './/birthday11.jpg';
import birthday12 from './/birthday12.jpg';
import birthday13 from './/birthday13.jpg';
import birthday14 from './/birthday14.jpg';
import birthday15 from './/birthday15.jpg';
import birthday16 from './/birthday16.jpg';
import birthday17 from './/birthday17.jpg';
import birthday18 from './/birthday18.jpg';
import birthday19 from './/birthday19.jpg';
import birthday20 from './/birthday20.jpg';
import birthday21 from './/birthday21.jpg';
import birthday22 from './/birthday22.jpg';
import birthday23 from './/birthday23.jpg';
import birthday24 from './/birthday24.jpg';
import birthday25 from './/birthday25.jpg';

export interface CustomImage {
  src: string;
  original: string;
  width: number;
  height: number;
}

export const images: CustomImage[] = [
  {
    src: birthday1,
    original: birthday1,
    width: 200,
    height: 200,
  },
  {
    src: birthday2,
    original: birthday2,
    width: 320,
    height: 212,
  },
  {
    src: birthday3,
    original: birthday3,
    width: 320,
    height: 212,
  },
  {
    src: birthday4,
    original: birthday4,
    width: 150,
    height: 213,
  },
  {
    src: birthday5,
    original: birthday5,
    width: 150,
    height: 183,
  },
  {
    src: birthday6,
    original: birthday6,
    width: 150,
    height: 320,
  },
  {
    src: birthday7,
    original: birthday7,
    width: 150,
    height: 200,
  },
  {
    src: birthday8,
    original: birthday8,
    width: 150,
    height: 148,
  },
  {
    src: birthday9,
    original: birthday9,
    width: 320,
    height: 213,
  },
  {
    src: birthday10,
    original: birthday10,
    width: 400,
    height: 320,
  },
  {
    src: birthday11,
    original: birthday11,
    width: 100,
    height: 113,
  },
  {
    src: birthday12,
    original: birthday12,
    width: 250,
    height: 320,
  },
  {
    src: birthday13,
    original: birthday13,
    width: 320,
    height: 213,
  },
  {
    src: birthday14,
    original: birthday14,
    width: 200,
    height: 194,
  },
  {
    src: birthday15,
    original: birthday15,
    width: 320,
    height: 213,
  },
  {
    src: birthday16,
    original: birthday16,
    width: 271,
    height: 320,
  },
  {
    src: birthday17,
    original: birthday17,
    width: 200,
    height: 320,
  },
  {
    src: birthday18,
    original: birthday18,
    width: 271,
    height: 320,
  },
  { src: birthday19, original: birthday19, width: 2400, height: 1600 },
  { src: birthday20, original: birthday20, width: 2400, height: 1600 },
  { src: birthday21, original: birthday21, width: 1600, height: 2400 },
  { src: birthday22, original: birthday22, width: 1600, height: 2400 },
  { src: birthday23, original: birthday23, width: 1600, height: 2400 },
  { src: birthday24, original: birthday24, width: 1600, height: 2400 },
  { src: birthday25, original: birthday25, width: 2400, height: 1600 },
  
  
];
